import { WithTheme } from '@issuemanager/apps/client/theme';
import { Stack, styled } from '@mui/material';
import React from 'react';

type Props = {
  children: React.JSX.Element[];
};

const StyledStack = styled(Stack)<WithTheme<{ index: number }>>(
  ({ theme, index }) => ({
    width: 'auto',
    minWidth: '50%',
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
    borderLeft:
      index % 2 === 1
        ? `1px solid ${theme.tokens.semantic.color.background.selected}`
        : 'none',
  }),
);

export function ColumnWrapStack({ children }: Props) {
  return (
    <Stack
      flexDirection='row'
      flexWrap='wrap'
      alignItems='flex-start'
      rowGap={1}
      marginBottom={2}
    >
      {children.map((child, index) => (
        <StyledStack index={index}>{child}</StyledStack>
      ))}
    </Stack>
  );
}
